import React from 'react';
import './RankMatchOpponentCountsModal.css';
import PageButton from '../elements/PageButton/PageButton';
import {MENU_SOUND_MANAGER} from '../../scenes/MenuSoundManager';
import {
  checkIfUnrestrictedOpponentCounts,
  RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT,
  RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS,
  RANK_MATCH_OPPONENT_COUNT_OPTIONS,
} from '../../configs/rankMatch';

const PAGE_ID = 'RankMatchOpponentCountsModal';

// «1 противник», «2/3/4 противника», «5 противников»
const getOpponentCountLabel = (count) => {
  if (count === 1) return '1 противник';
  if (count <= 4) return `${count} противника`;
  return `${count} противников`;
};


/**
 * Модалка выбора ограничения матч-мейкинга по числу противников (rankMatch.js):
 * опции 1-5 противников (матчи 2-6 игроков), сверху «Выбрать все». Выбраны
 * все = без ограничений. Меньше RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS
 * опций оставить нельзя. Каждое изменение немедленно уходит на сервер
 * через onChange (см. RankMatchSetup.handleOpponentCountsChange). Открывается
 * только с экрана настройки поиска: во время поиска ограничение не меняется.
 * Стилизована под модалки главного меню (NotEnoughFactionsModal), чекбоксы —
 * как переключатели таймера/быстрого режима в сетевом лобби (lobby-checkbox).
 */
const RankMatchOpponentCountsModal = ({opponentCounts, onChange, handleClose}) => {
  const isUnrestricted = checkIfUnrestrictedOpponentCounts(opponentCounts);

  const handleToggle = (count) => {
    const isSelected = opponentCounts.includes(count);
    if (isSelected && opponentCounts.length <= RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS) {
      return; // минимум выбранных опций — снятие заблокировано (см. подсказку)
    }
    MENU_SOUND_MANAGER.playMenuButtonClick();
    if (isSelected) {
      onChange(opponentCounts.filter((selectedCount) => selectedCount !== count));
    } else {
      onChange([...opponentCounts, count].sort((a, b) => a - b));
    }
  };

  const handleSelectAll = () => {
    if (isUnrestricted) {
      return;
    }
    MENU_SOUND_MANAGER.playMenuButtonClick();
    onChange([...RANK_MATCH_OPPONENT_COUNT_OPTIONS]);
  };

  return (
    <div className="rank-match-opponent-counts-overlay" onClick={handleClose} role="dialog" aria-modal="true">
      <div className="rank-match-opponent-counts-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="rank-match-opponent-counts-title">Количество противников</h2>

        <div className="rank-match-opponent-counts-options">
          <label className="lobby-checkbox rank-match-opponent-counts-option rank-match-opponent-counts-option_all">
            <input
              type="checkbox"
              checked={isUnrestricted}
              onChange={handleSelectAll}
            />
            <span>Выбрать все (без ограничений)</span>
          </label>

          {RANK_MATCH_OPPONENT_COUNT_OPTIONS.map((count) => {
            const [minMinutes, maxMinutes] = RANK_MATCH_DURATION_MINUTES_BY_OPPONENT_COUNT[count];
            return (
              <label key={count} className="lobby-checkbox rank-match-opponent-counts-option">
                <input
                  type="checkbox"
                  checked={opponentCounts.includes(count)}
                  onChange={() => handleToggle(count)}
                />
                <span className="rank-match-opponent-counts-option_text">
                  <span>{getOpponentCountLabel(count)}</span>
                  <span className="rank-match-opponent-counts-option_duration">
                    {`Длительность матча: ${minMinutes} - ${maxMinutes} минут`}
                  </span>
                </span>
              </label>
            );
          })}
        </div>

        {/* ВРЕМЕННО: минимум ослаблен до 1 опции (rankMatch.js) — подсказка
            про минимум скрыта; при восстановлении константы = 2 условие ниже
            снова покажет ее без правок здесь */}
        {RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS > 1 && (
          <p className="rank-match-opponent-counts-hint">
            {`Нужно оставить минимум ${RANK_MATCH_MIN_SELECTED_OPPONENT_COUNTS} варианта`}
          </p>
        )}
        {!isUnrestricted && (
          <p className="rank-match-opponent-counts-modal-warning">
            Время ожидания может быть увеличено
          </p>
        )}

        <div className="main-menu-buttons rank-match-opponent-counts-buttons">
          <PageButton onClick={handleClose} pageId={PAGE_ID} buttonId="close">
            Закрыть
          </PageButton>
        </div>
      </div>
    </div> 
  );
};

export default RankMatchOpponentCountsModal;
